import React, { useEffect, useState } from "react";
import TitleUnderlined from "../../components/TitleUnderlined";
import Row from "../../components/Row";
import Column from "../../components/Column";
import Button from "../../components/Button";
import Divider from '../../components/Divider';
import Card from "../../components/Card";
import { Link, useNavigate } from "react-router-dom";
import { RoutesWeb } from "../../tools/RoutesWeb";
import APIInterface from "../../tools/APIInterface";
import { ShimmerTitle } from "../../components/Shimmer";
require('../../style/views/dashboardView.scss');

const DashboardView = () => {
    const token = localStorage.getItem('tokenAdmin');
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        if(!token) {
            navigate(RoutesWeb.ADMIN_LOGIN);
        }
    });

    if(data === null) {
        APIInterface.dashboard(token)
        .then((response) => {
            setData(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    const isDataValid = () => {
        return data !== null;
    }


    return (
        <div className="pt-5 pb-5" id="dashboardView">
            <br></br>
            <br></br>
            <TitleUnderlined>Reporte del <span className="embercom_overlined">evento</span></TitleUnderlined>
            <br />
            <br />
            <Row>
                <Column className="col-md-6">
                    <Card className="mb-3">
                        <h3><b>Boletos comprados en línea</b></h3>
                        <h1 className="subtitle"><b>
                            {isDataValid() ? 
                                data.online_tickets
                            :
                            <ShimmerTitle line={1} />
                            }
                        </b></h1>
                    </Card>
                </Column>
                <Column className="col-md-6 text-center">
                    <Button style={{maxWidth: '400px'}}>
                    <a href={`${process.env.REACT_APP_API_URL}/api/download/bought/attendees`} target="_blank" rel="noreferrer" style={{textDecoration: "none",color: "black"}}>
                            <Row className="align-items-center">
                                <Column className="col-8" strict>
                                    Descargar lista de boletos comprados
                                </Column>
                                <Column className="col-4" strict><img src={require('../../assets/download.png')} alt="downloadIcon" style={{marginLeft: '10px', width: '25px', height: '25px', maxHeight: '25px'}} /></Column>
                            </Row>
                        </a>
                    </Button>
                </Column>
            </Row>
            <br />
            <Divider style={{opacity: '0.15'}} />
            <Row className="mt-4">
                <Column className="col-md-6">
                    <Card>
                        <h3><b>Boletos reservados</b></h3>
                        <h1 className="subtitle"><b>
                            {isDataValid() ?
                                data.reserved_tickets
                            :
                                <ShimmerTitle line={1} />
                            }    
                        </b></h1>
                    </Card>
                    <br />
                    <Divider style={{opacity: '0.15'}} />
                    <br />
                    <Card className="mb-3">
                        <h3><b>Boletos disponibles</b></h3>
                        <h1 className="subtitle"><b>
                            {isDataValid() ?
                                data.available_tickets
                            :
                                <ShimmerTitle line={1} />
                            }    
                        </b></h1>
                    </Card>
                </Column>
                <Column className="col-md-6 text-center">
                    <Button style={{maxWidth: '400px'}}>
                        <a href={`${process.env.REACT_APP_API_URL}/api/download/attendees`} target="_blank" rel="noreferrer" style={{textDecoration: "none",color: "black"}}>
                            <Row className="align-items-center">
                                <Column className="col-8" strict>
                                    Descargar lista de boletos reservados
                                </Column>
                                <Column className="col-4" strict><img src={require('../../assets/download.png')} alt="downloadIcon" style={{marginLeft: '10px', width: '25px', height: '25px', maxHeight: '25px'}} /></Column>
                            </Row>
                        </a>
                    </Button>
                    <br />
                    <br />
                    <Link className="btn btn-main bg-blue py-3" to={RoutesWeb.ADMIN_ADD_LEADER}>
                        <Row className="align-items-center">
                            <Column className="col-8" strict>
                                Añadir lider
                            </Column>
                            <Column className="col-4" strict><img src={require('../../assets/user2.png')} alt="userIcon" style={{marginLeft: '10px', width: '25px', height: '20px', maxHeight: '25px'}} /></Column>
                        </Row>
                    </Link>
                    <br />
                    <br />
                    <Link className="btn btn-main py-3" to={RoutesWeb.ADMIN_LEADERS}>
                        <Row className="align-items-center">
                            <Column className="col-8" strict>
                                Ver lista de lideres
                            </Column>
                            <Column className="col-4" strict><img src={require('../../assets/user.png')} alt="userIcon" style={{marginLeft: '10px', width: '25px', height: '25px', maxHeight: '25px'}} /></Column>
                        </Row>
                    </Link>
                    <br />
                    <br />
                    <Link className="btn btn-main py-3" to={RoutesWeb.ADMIN_DECANATO_LOADS}>
                        <Row className="align-items-center">
                            <Column className="col-8" strict>
                                Historial de cargas decanatos
                            </Column>
                            <Column className="col-4" strict><img src={require('../../assets/download.png')} alt="historyIcon" style={{marginLeft: '10px', width: '25px', height: '25px', maxHeight: '25px'}} /></Column>
                        </Row>
                    </Link>
                </Column>
            </Row>
            <br />
            <br />
            <br />
            <br />
        </div>
    )
}

export default DashboardView;